import { ReactComponent as DBReservationsIcon } from "assets/icons/dashboardIcons/DB-prov-seek-reservation.svg";
import { ReactComponent as CurrentBookingsIcon } from "assets/icons/dashboardIcons/DB-prov-seek-resaencoursNOIR.svg";
import { ReactComponent as HistoryIcon } from "assets/icons/dashboardIcons/DB-prov-seek-historiqueNOIR.svg";
import { ReactComponent as FavoritesIcon } from "assets/icons/dashboardIcons/DB-seek-mesfavorisNOIR.svg";
import { ReactComponent as RatingsIcon } from "assets/icons/dashboardIcons/DB-seek-notationNOIR.svg";
import { ReactComponent as FacturationIcon } from "assets/icons/dashboardIcons/DB-seek-facturation.svg";
import { ReactComponent as PaymentMethodsIcon } from "assets/icons/dashboardIcons/DB-seek-moyenpaiementNOIR.svg";
import { ReactComponent as InvoicesIcon } from "assets/icons/dashboardIcons/DB-prov-seek-facturesNOIR.svg";
import { ReactComponent as InformationIcon } from "assets/icons/dashboardIcons/DB-prov-seek-information.svg";
import { ReactComponent as ContactsInfoIcon } from "assets/icons/dashboardIcons/DB-prov-seek-informationsocieteNOIR.svg";
import { ReactComponent as PasswordAndAccessIcon } from "assets/icons/dashboardIcons/DB-prov-motdepasseNOIR.svg";
import { ReactComponent as MessagesIcon } from "assets/icons/dashboardIcons/DB-prov-seek-messagesNOIR.svg";
import {ReactComponent as CommissionInvoicesIcon} from "assets/icons/dashboardIcons/DB-prov-facture-commissionNOIR.svg";
import {ReactComponent as SpacesCategoryIcon} from "assets/icons/dashboardIcons/DB-prov-espaces.svg";
import {ReactComponent as ManageSpacesIcon} from "assets/icons/dashboardIcons/DB-prov-gererespaceNOIR.svg";
import {ReactComponent as AddSpaceIcon} from "assets/icons/dashboardIcons/DB-prov-ajoutespaceNOIR.svg";
import {ReactComponent as MyContractIcon} from "assets/icons/dashboardIcons/DB-prov-cgvNOIR.svg";
import {ReactComponent as CgvIcon} from "assets/icons/dashboardIcons/DB-prov-cgvNOIR.svg";
import {ReactComponent as LockIcon} from "assets/icons/dashboardIcons/lockIcon.svg";
import {ReactComponent as PromoIcon} from "assets/icons/dashboardIcons/promoIcon.svg";
export const menuCategoriesData = {
  seeker: [
    {
      categoryKey: "sidebar_reservations",
      categoryIcon: DBReservationsIcon,
      items: [
        {
          labelKey: "seeker.reservations",
          icon: CurrentBookingsIcon,
          route: "/dashboard/bookings",
        },
        {
          labelKey: "seeker.history",
          icon: HistoryIcon,
          route: "/dashboard/history",
        },
        {
          labelKey: "seeker.favorites",
          icon: FavoritesIcon,
          route: "/dashboard/favorites",
        },
           {
          labelKey: "seeker.promoCodes",
          icon: PromoIcon,
          route: "/dashboard/promo-codes-seeker",
        },
        {
          labelKey: "seeker.myRatings",
          icon: RatingsIcon,
          route: "/dashboard/ratings",
        },
      ],
    },
    {
      categoryKey: "facturation",
      categoryIcon: FacturationIcon,
      items: [
        {
          labelKey: "seeker.meansOfPayment",
          icon: PaymentMethodsIcon,
          route: "/dashboard/cards",
        },
        {
          labelKey: "provider.bookingInvoice",
          icon: InvoicesIcon,
          route: "/dashboard/bookinginvoices",
        },
        // Add Training Invoices item here
        {
          icon: InvoicesIcon, // or a different icon if preferred
          masterSeekerOnly: true, // Add this flag to identify it
          labelKey: "provider.trainingInvoices",
          route: "/dashboard/traininginvoices",
        },

      ],
    },
    {
      categoryKey: "informations",
      categoryIcon: InformationIcon,
      items: [
        {
          labelKey: "seeker.contact",
          icon: ContactsInfoIcon,
          route: "/dashboard/contact",
        },
        {
          labelKey: "provider.accessAndPassword",
          icon: PasswordAndAccessIcon,
          route: "/dashboard/access",
        },
        {
          labelKey: "seeker.myMessages",
          icon: MessagesIcon,
          route: "/dashboard/messages",
        },
      
      ],
    },
  ],
  provider: [
    {
      categoryKey: "sidebar_reservations",
      categoryIcon: DBReservationsIcon,
      items: [
        {
          icon: CurrentBookingsIcon,
          route: "/dashboard/bookings",
          labelKey: "provider.reservations",
        },
        {
          icon: HistoryIcon,
          route: "/dashboard/history",
          labelKey: "provider.history",
        },
        {
          icon: InvoicesIcon,
          route: "/dashboard/bookinginvoices",
          labelKey: "provider.bookingInvoice",
        },
        {
          icon: CommissionInvoicesIcon,
          route: "/dashboard/invoices",
          labelKey: "provider.invoicesCommission",
        },
        
      ],
    },
    {
      categoryKey: "spaces",
      categoryIcon: SpacesCategoryIcon,
      items: [
        {
          labelKey: "provider.spaceManagement",
          icon: ManageSpacesIcon,
          route: "/dashboard/spaces",
        },
        {
          labelKey: "provider.addSpace",
          icon: AddSpaceIcon,
          route: "/create-space/step1",
        },
        {
          labelKey: "provider.locksManagement",
          icon: LockIcon,
          route: "https://www.locks.chooseandwork.com/login",
        },
      ],
    },
    {
      categoryKey: "informations",
      categoryIcon: InformationIcon,
      items: [
        {
          labelKey: "provider.contact",
          icon: ContactsInfoIcon,
          route: "/dashboard/contact",
        },
        {
          labelKey: "provider.myContract",
          icon: MyContractIcon,
          route: "/dashboard/contract",
        },
        {
          labelKey: "provider.accessAndPassword",
          icon: PasswordAndAccessIcon,
          route: "/dashboard/access",
        },
        {
          labelKey: "provider.cgvManagement",
          icon: CgvIcon,
          route: "/dashboard/cgv",
        },
        {
          labelKey: "provider.messages",
          icon: MessagesIcon,
          route: "/dashboard/messages",
        },
        {
          labelKey: "provider.promoCodes",
          icon: PromoIcon,
          route: "/dashboard/promo-codes",
        },
      ],
    },
  ],
};
